
import { Options, Prop, Vue } from 'vue-property-decorator'
import Button from 'primevue/button'
import { subMinutes } from 'date-fns'
import { query } from '@madxnl/mrrabbit'

function toDatetimeLocal(value: Date) {
  const year = value.getFullYear()
  const month = String(value.getMonth() + 1).padStart(2, '0')
  const day = String(value.getDate()).padStart(2, '0')
  const hours = String(value.getHours()).padStart(2, '0')
  const minutes = String(value.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day}T${hours}:${minutes}`
}

@Options({
  components: {
    Button,
  },
})
export default class BagRecordingDownloader extends Vue {
  @Prop()
  modelId: string

  loading = false
  useLatestWindow = true
  startDate = toDatetimeLocal(subMinutes(new Date(), 10))
  endDate = toDatetimeLocal(new Date())

  getErrorMessage(error: unknown) {
    const graphqlMessage = (error as any)?.response?.errors?.[0]?.message
    if (typeof graphqlMessage === 'string' && graphqlMessage.length > 0) {
      return graphqlMessage
    }
    return error instanceof Error ? error.message : 'Unexpected error'
  }

  async downloadRecording() {
    try {
      this.loading = true
      const { startDate, endDate } = this.getWindow()
      const result = await query(
        'prepareRecordingDownload',
        {
          variables: {
            prepareRecordingDownload: {
              bagId: this.modelId,
              startDate,
              endDate,
            },
          },
        },
      )

      if (result.prepareRecordingDownload != null) {
        this.download(result.prepareRecordingDownload)
      }
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: 'Download failed',
        detail: this.getErrorMessage(error),
        life: 3000,
      })
    } finally {
      this.loading = false
    }
  }

  getWindow() {
    if (this.useLatestWindow) {
      const end = new Date()
      const start = subMinutes(end, 10)
      return {
        startDate: start.toISOString(),
        endDate: end.toISOString(),
      }
    }

    return {
      startDate: new Date(this.startDate).toISOString(),
      endDate: new Date(this.endDate).toISOString(),
    }
  }

  download(ref: string) {
    const link = document.createElement('a')
    link.href = ref
    link.rel = 'noopener'
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
